import { alpha, Theme } from '@mui/material'

const classes = {
  skrim: (theme: Theme) => ({
    backgroundColor: alpha(theme.palette.ui.onPrimaryFixedVariant, 0.08),
    backdropFilter: 'blur(5px)',
    width: '100vw',
    height: '100vh',
    position: 'fixed' as const,
  }),
}

export default classes
